import schemaResolver from '.';

/**
 * Event schema resolver.
 * This pure function transforms event detail objects to schema.
 */
export const eventResolver = (event, eventReviews) => {
  return (
    event && {
      name: event.title,
      url: event.canonical,
      // Excerpt is optional
      ...(event.excerpt && {
        description: event.excerpt,
      }),
      // Start date is optional
      ...(event.startDate && {
        startDate: event.startDate,
      }),
      // Location is optional
      ...(event.location &&
        (event.location.address ||
          (event.location.lat && event.location.lat)) && {
          location: {
            '@type': 'Place',
            // Address is optional
            ...(event.location.address && {
              address: event.location.address.join(', '),
              name: event.location.address.join(', '),
            }),
            // Coordinates are optional
            ...(event.location.lat &&
              event.location.lat && {
                geo: {
                  '@type': 'GeoCoordinates',
                  latitude: event.location.lat,
                  longitude: event.location.long,
                },
              }),
          },
        }),
      // Image is optional
      ...(event.images &&
        event.images.hero &&
        event.images.hero.title !== 'stub image' && {
          image: [event.images.hero.large],
        }),
      // Organizer is optional
      ...(event.organiser && {
        organizer: {
          '@type': 'Organization',
          name: event.organiser.title,
        },
      }),
      // Reviews are optional
      // todo currently eventReviews are undefined, move resolver to EventCard!
      ...(eventReviews &&
        eventReviews.ratings && {
          aggregateRating: {
            '@type': 'AggregateRating',
            bestRating: 5,
            worstRating: 1,
            ratingCount: eventReviews.total,
            ratingValue: eventReviews.ratings.overall,
          },
        }),
    }
  );
};

const resolver = (event, eventReviews) =>
  schemaResolver(eventResolver(event, eventReviews), 'Event');

export default resolver;
